import { type Avatar as AvatarT, type Color, flairOf, isCpu } from '@xox/shared'
import { COLOR_CLASSES } from '../lib/flair'
import { RobotFace, robotPaletteFor } from './art/RobotFace'

const SIZES = {
  sm: 'size-7 text-base',
  md: 'size-10 text-xl',
  lg: 'size-12 text-2xl',
  xl: 'size-16 text-3xl',
} as const

interface Props {
  id: string
  avatar?: AvatarT | null
  color?: Color | null
  size?: keyof typeof SIZES
  /** House bots only: pulse the eyes while it is on move. */
  thinking?: boolean
  className?: string
}

export function Avatar({
  id,
  avatar,
  color,
  size = 'md',
  thinking = false,
  className = '',
}: Props) {
  const flair = flairOf({ id, avatar, color })
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full leading-none ${SIZES[size]} ${COLOR_CLASSES[flair.color]} ${className}`}
      aria-hidden
    >
      {isCpu(id) ? (
        <RobotFace thinking={thinking} palette={robotPaletteFor(id)} className="size-[82%]" />
      ) : (
        flair.avatar
      )}
    </div>
  )
}
